import { REDUCER_NAME as APP_REDUCER_NAME } from 'constants';
import { REDUCER_NAME } from './constants';

export const getState = (state) => state[APP_REDUCER_NAME][REDUCER_NAME][REDUCER_NAME];

export const getManifestState = (state) => state[APP_REDUCER_NAME][REDUCER_NAME];

export const getResults = (state) => getState(state).data;

export const getFilters = (state) => getState(state).filters;

export const getIsFetching = (state) => getState(state).isFetching;

export const getHasNext = (state) => getState(state).nextCursor != null;

export const getCurrentCursor = (state) => getState(state).cursor;

export const getCache = (state) => getState(state).cache;

export const getFromCache = (state, key) => getCache(state)[key];

export const getHasCache = (state, key) => getFromCache(state, key) !== undefined;

export const getHasPrev = (state) => {
  const cursor = getCurrentCursor(state);

  if (getHasCache(state, cursor)) {
    const cache = getFromCache(state, cursor);
    return typeof cache.prevCursor !== 'undefined';
  }

  return true;
};

export const getNextCursor = (state) => getState(state).nextCursor;

export const getPrevCursor = (state) => {
  const cursor = getCurrentCursor(state);

  if (getHasCache(state, cursor)) {
    return;
  }

  const cache = getFromCache(state, cursor);

  return cache.prevCursor;
};
